<template>
    <div
        class="etapa-opcao"
        :class="{
            'etapa-opcao--on': escolhido,
            'etapa-opcao--off': !habilitado && !escolhido,
        }"
        :style="{ '--et-primaria': corPrimaria }"
        role="button"
        tabindex="0"
        @click="$emit('tocar', complemento)"
    >
        <v-img
            v-if="imagem"
            :src="imagem"
            eager
            max-width="46"
            height="46"
            class="etapa-opcao__foto"
        />

        <div class="etapa-opcao__txt">
            <div v-if="chipEstoque" class="etapa-opcao__estoque">{{ chipEstoque }}</div>
            <div class="etapa-opcao__nome">{{ complemento.descricao }}</div>
            <div v-if="complemento.detalhes" class="etapa-opcao__det">{{ complemento.detalhes }}</div>
        </div>

        <span v-if="indisponivel" class="etapa-opcao__indisponivel">Indisponível</span>

        <span v-if="+complemento.valor" class="etapa-opcao__preco">
            + {{ moeda() }} {{ formatPrice(+complemento.valor) }}
        </span>

        <span v-if="unica" class="etapa-opcao__radio" />

        <QuantidadeStepper
            v-else-if="escolhido"
            :value="complemento.quantidade || 0"
            :can-increment="podeIncrementar"
            :editable="editavel"
            :label="`Quantidade de ${complemento.descricao}`"
            @increment="$emit('somar', complemento)"
            @decrement="$emit('remover', complemento)"
            @change="$emit('quantidade', { complemento, quantidade: $event })"
        />

        <span v-else class="etapa-opcao__mais">
            <v-icon>mdi-plus</v-icon>
        </span>
    </div>
</template>

<script>
import QuantidadeStepper from '@/components/QuantidadeStepper';
import { escolhaUnica, isIndisponivel, podeSomar, podeTocar } from '@/utils/etapa';

export default {
    name: 'EtapaOpcao',

    components: { QuantidadeStepper },

    props: {
        passo: { type: Object, required: true },
        complemento: { type: Object, required: true },
        chipEstoque: { type: String, default: '' },
        editavel: { type: Boolean, default: false },
    },

    computed: {
        unica() {
            return escolhaUnica(this.passo);
        },

        escolhido() {
            return +this.complemento.quantidade > 0;
        },

        indisponivel() {
            return isIndisponivel(this.complemento);
        },

        habilitado() {
            return podeTocar(this.passo, this.complemento);
        },

        podeIncrementar() {
            return podeSomar(this.passo, this.complemento);
        },

        corPrimaria() {
            return this.$vuetify.theme.currentTheme.primary;
        },

        imagem() {
            const anexos = this.complemento?.imagens;
            const anexo = Array.isArray(anexos) ? anexos[0] : anexos;

            if (!anexo?.url) return null;

            return anexo.tmp
                ? `${this.$urlAPI}/files/tmp/${anexo.url}`
                : `${this.$urlAPI}/storage/${anexo.url}`;
        },
    },
};
</script>

<style scoped>
.etapa-opcao {
    display: flex;
    align-items: center;
    gap: 11px;
    padding: 9px 12px;
    border: 2px solid rgba(128, 128, 128, 0.25);
    border-radius: 12px;
    cursor: pointer;
    min-height: 62px;
    transition: border-color 0.12s, background 0.12s;
    user-select: none;
}
.etapa-opcao--on {
    border-color: var(--et-primaria);
    background: rgba(128, 128, 128, 0.07);
}
.etapa-opcao--off { opacity: 0.42; cursor: not-allowed; }

.etapa-opcao__foto { border-radius: 8px; flex: none; }
.etapa-opcao__txt { flex: 1; min-width: 0; }
.etapa-opcao__nome {
    font-size: 15px;
    font-weight: 600;
    line-height: 1.25;
    text-transform: uppercase;
}
.etapa-opcao__det {
    font-size: 12px;
    color: #8b9098;
    margin-top: 1px;
    overflow-wrap: anywhere;
}
.etapa-opcao__estoque {
    display: inline-block;
    background: #8009e5;
    color: #fff;
    border-radius: 4px;
    padding: 0 6px;
    font-size: 11px;
    line-height: 17px;
    margin-bottom: 3px;
}

.etapa-opcao__preco { font-size: 13.5px; font-weight: 700; color: #0f8a3d; white-space: nowrap; }
.etapa-opcao__indisponivel {
    background: rgba(217, 48, 37, 0.12);
    color: #c5221f;
    border-radius: 20px;
    padding: 2px 9px;
    font-size: 11px;
    font-weight: 800;
    text-transform: uppercase;
    white-space: nowrap;
}
.theme--dark .etapa-opcao__indisponivel { color: #f28b82; }

.etapa-opcao__radio {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    border: 2px solid rgba(128, 128, 128, 0.45);
    flex: none;
    transition: border 0.12s;
}
.etapa-opcao--on .etapa-opcao__radio { border: 8px solid var(--et-primaria); }

.etapa-opcao__mais {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 2px solid rgba(128, 128, 128, 0.35);
    flex: none;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #8b9098;
}
.etapa-opcao:hover .etapa-opcao__mais { border-color: var(--et-primaria); color: var(--et-primaria); }
</style>
